import { PeOrderDetail } from 'model/modules/pe/orders/peOrderDetail';
import mapPeCompanyDetailFromApi from 'rtkQuery/sharespro/mapper/modules/pe/peCompany/mapPeCompanyDetailFromApi';
import mapChartDataFromApi from 'rtkQuery/sharespro/mapper/shared/mapChartDataFromApi';

const mapPeOrderDetailFromApi = (resp: ApiPeOrderDetail): PeOrderDetail => {
  return {
    id: resp.id,
    company: mapPeCompanyDetailFromApi(resp.company),
    chartData: mapChartDataFromApi(resp.chart),
    isAllowCancel: resp.is_allowed_cancel,
    price: resp.price,
    operationType: resp.operation,
    quantity: resp.quantity,
    lock_up: resp.lock_up,
  };
};

export default mapPeOrderDetailFromApi;
